// src/pages/xray/XrayLobby/UploadSection.js
import React from 'react';

const UploadSection = ({ fileName, handleFileChange }) => (
  <div className="w-1/5 flex flex-col items-center justify-center text-center bg-white shadow-lg rounded-lg p-6 border border-gray-200">
    <h1 className="text-4xl font-semibold pb-2">X-Ray</h1>
    <img src="../img/xray-hand.png" alt="X-ray Logo" className="w-32 h-32" />
    <h2 className="text-3xl font-semibold pb-2">Upload</h2>
    <h2 className="text-2xl font-semibold pb-2 text-red-600">sys_report.log</h2>
    <input
      type="file"
      accept=".log"
      onChange={handleFileChange}
      className="hidden"
      id="fileInput"
    />
    <button
      onClick={() => document.getElementById('fileInput').click()}
      className="px-4 py-1 bg-green-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-green-800 hover:border-green-700 mt-2"
    >
      Choose File
    </button>
    <span className="pt-2">
      <b>File Selected:</b> {fileName}
    </span>
  </div>
);

export default UploadSection;
